import {AppState} from "../store";

export const getAllocatableLoadInventorySearchPageFilter = (state: AppState) => state.allocatableLoadInventorySearchPage.filter
